import { render, staticRenderFns } from "./address-fields.vue?vue&type=template&id=862b3de6&lang=pug"
import script from "./address-fields.vue?vue&type=script&lang=js"
export * from "./address-fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports